import { Component, EventEmitter, Input, Output } from '@angular/core';
import Highcharts from 'highcharts';
import { NgClass } from '@angular/common';
import { DonutComponent } from '@shared/components/highcharts/donut/donut.component';
import { NumberFormatPipe } from '@shared/pipe/filter.pipe';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrl: './dashboard-card.component.scss',
  imports: [NgClass, DonutComponent, NumberFormatPipe],
})
export class DashboardCardComponent {
  @Input({ required: true }) bgColor: string;
  @Input({ required: true }) title: string;
  @Input() total: number;
  @Input() breakdown: Highcharts.Options;
  @Input({ required: true }) isLoading: boolean = false;

  @Output() selectSite = new EventEmitter<string>();
  @Output() clickTitle = new EventEmitter<void>();
}
